import { useFormatFilterWidgetValue } from '#src/hooks/search/useFormatFilterWidgetValue/index.tsx';
import { FilterChip } from '#src/search/ActiveFilters/FilterChip/index.tsx';
import type { RefinementItem } from '#src/search/ActiveFilters/types.ts';

export const ListActiveFilter = ({ item }: { item: RefinementItem }) => {
  const { formatFilterWidgetValue } = useFormatFilterWidgetValue();

  const labels = formatFilterWidgetValue(item);

  return (
    <>
      {item.refinements.map((refinement, i) => {
        const label = labels[i];

        return (
          <FilterChip
            key={refinement.label}
            label={label}
            onClose={() => {
              item.refine(refinement);
            }}
          />
        );
      })}
    </>
  );
};
